module.exports = __webpack_public_path__ + "static/media/forpatient1@2x.57bfb4ac.png";